import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import { fetchBatches, updateBatch } from "./batchThunk";

interface BatchSliceState {
  batches: any[];
  rowCount: number;
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: BatchSliceState = { batches: [], rowCount: 0, status: ApiStatus.IDLE, errorMessage: "" };

// Endpoint returns { data, total }; tolerate a bare array too.
const readRows = (payload: any): any[] => (Array.isArray(payload) ? payload : payload?.data ?? []);
const readTotal = (payload: any): number => (Array.isArray(payload) ? payload.length : Number(payload?.total) || 0);

const batchSlice = createSlice({
  name: "batch",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatches.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchBatches.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.batches = readRows(action.payload);
        state.rowCount = readTotal(action.payload);
        state.errorMessage = "";
      })
      .addCase(fetchBatches.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(updateBatch.fulfilled, () => { toast.success("Batch updated"); })
      .addCase(updateBatch.rejected, (state, action) => { toast.error(action.error.message || "Failed to update batch"); });
  },
});

export default batchSlice.reducer;
